import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function TmovLogo({ size, color }: IconProps) {
  return (
    <svg
      width={(size || 24) * 4.275862069}
      height={size || 24}
      viewBox="0 0 124 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>TmovLogo</title>
      <path
        d="M0 8.90167L4.91678 3.98063C6.30894 2.58727 8.19527 1.80591 10.1643 1.80591H28.3008V8.86125L18.7807 8.87472V27.7775H11.7314V8.88434L0 8.90167Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M77.6521 7.87982C81.4594 7.87982 84.5571 10.9802 84.5571 14.7908C84.5571 18.6014 81.4594 21.7018 77.6521 21.7018C73.8448 21.7018 70.7471 18.6014 70.7471 14.7908C70.7471 10.9802 73.8448 7.87982 77.6521 7.87982ZM77.6521 0.628174C69.8376 0.628174 63.5017 6.96951 63.5017 14.7908C63.5017 22.6121 69.8376 28.9535 77.6521 28.9535C85.4666 28.9535 91.8025 22.6121 91.8025 14.7908C91.8025 6.96951 85.4666 0.628174 77.6521 0.628174Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M113.085 1.8042L115.858 4.5813L102.652 17.799V1.8042H95.2524V27.7758H99.577C101.544 27.7758 103.432 26.9925 104.824 25.6011L120.842 9.56969L123.615 12.3468V1.8042H113.085Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M45.9013 8.9115L50.8296 3.97892C52.2217 2.58556 54.1081 1.8042 56.0771 1.8042H60.0536V27.7758H53.0024V11.883L45.9013 18.9903L38.8001 11.883V27.7777H31.7509V1.8042H35.7274C37.6944 1.8042 39.5827 2.58748 40.9749 3.97892L45.9013 8.9115Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
